import { Chip } from "@mui/material";

const StatusChip = ({ status }) => (
    <Chip
      label={status}
      color={status === "Activo" ? "success" : "default"}
      size="small"
      sx={{ minWidth: 80 }}
    />
  );

export default StatusChip;